export default "__VITE_ASSET__854470b4__"